import { useState } from 'react';
import { useSelector } from 'react-redux';

import { CONFIG } from 'src/global-config';

import { PageSeo } from 'src/components/seo';

import { ProductShopView } from 'src/sections/product/view';

const metadata = { title: `Aktiviteler - ${CONFIG.appName}` };

export default function Page() {
  const accessTokenJSON = localStorage.getItem('auth') as string;
  const accessToken = JSON.parse(accessTokenJSON)?.accessToken ?? null;

  const {
    anonymous_listingListWithActivitiesAndBlogListData,
    anonymous_listingListWithActivitiesAndBlogListLoading,
  } = useSelector((state: any) => state.anonymous_listingListWithActivitiesAndBlogList);
  const { parent_listingListWithActivityAndBlogListData, parent_listingListWithActivityAndBlogListLoading } = useSelector(
    (state: any) => state.parent_listingListWithActivityAndBlogList
  );
  const [categoryName, setCategoryName] = useState('Aktiviteler');

  return (
    <>
      <PageSeo title={metadata.title} />

      <ProductShopView
        products={
          accessToken
            ? parent_listingListWithActivityAndBlogListData?.data
            : anonymous_listingListWithActivitiesAndBlogListData?.data
        }
        productsCount={
          accessToken
            ? parent_listingListWithActivityAndBlogListData?.count
            : anonymous_listingListWithActivitiesAndBlogListData?.count
        }
        loading={
          accessToken
            ? parent_listingListWithActivityAndBlogListLoading
            : anonymous_listingListWithActivitiesAndBlogListLoading
        }
        categoryName={categoryName}
        setCategoryName={setCategoryName}
      />
    </>
  );
}
